export const startSession = 'UserSession/StartSession';
export const closeSession = 'UserSession/CloseSession';
export const requestLogin = 'UserSession/RequestLoginLink';
export const weatherGet = 'WeatherForecast/GetForecasts';

export const tooManyRequests = 'Too many requests';
export const unauthorized = 'Unauthorized';

export const failure = 'failure';
